import {
  NEWSLETTER_UNSUB_URL_PATTERN,
  NEWSLETTER_UNSUB_WEBHOOK_URL,
} from '../config.js';
import { logger } from '../utils/logger.js';

/**
 * Vrai si l'URL courante est la page de désinscription newsletter.
 */
export function isNewsletterUnsubPage(pathname: string = window.location.pathname): boolean {
  return pathname.includes(NEWSLETTER_UNSUB_URL_PATTERN);
}

/**
 * Sur la page /contact/inscription-nl, si les query params
 * `email` et `unsub_campaign_name` sont présents, POST au webhook Make.com
 * pour traiter la désinscription.
 *
 * No-op si :
 * - Pas sur la page d'unsub
 * - Les deux params ne sont pas présents
 * - Le fetch échoue (logué, pas de throw)
 */
export function handleNewsletterUnsubPage(): void {
  if (!isNewsletterUnsubPage()) return;

  const params = new URLSearchParams(window.location.search);
  const email = (params.get('email') ?? '').trim();
  const campaignName = (params.get('unsub_campaign_name') ?? '').trim();

  if (!email || !campaignName) {
    logger.info('Unsub page sans params valides (email ou unsub_campaign_name manquant)');
    return;
  }

  logger.info('Newsletter unsub détectée:', { email, campaignName });

  fetch(NEWSLETTER_UNSUB_WEBHOOK_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      email,
      campaign_name: campaignName,
    }),
  })
    .then((response) => {
      if (response.ok) {
        logger.info('Webhook unsub envoyé avec succès');
      } else {
        logger.warn('Webhook unsub retourne un statut', response.status);
      }
    })
    .catch((error) => {
      logger.error('Erreur envoi webhook unsub:', error);
    });
}
